import React from 'react';
import './ContactForm.css';
function FormSuccess() {
    return ( <>
    <div className='form-content-right'>
        
        <h1 className='form-success'>We have received your information!! Thank You!!</h1>
        <img className='form-img-2' src="https://images.pexels.com/photos/158827/field-corn-air-frisch-158827.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt= "success image"/>
        
    </div>
    </> );
}

export default FormSuccess;